import React from 'react';
import {Button, ButtonToolbar} from 'react-bootstrap';

import dateModes from './utils/dateModes';

const GanttControls = ({
  onBackClickedComposite,
  onFwdClickedComposite,
  onDayModeClick,
  onWeekModeClick,
  onMonthModeClick,
}) => (
  <React.Fragment>
    <ButtonToolbar className="gantt--controls-move" aria-label="Gantt back and forward buttons">
      <Button onClick={onBackClickedComposite}>Back</Button>
      <Button onClick={onFwdClickedComposite}>Forward</Button>
    </ButtonToolbar>
    
    <ButtonToolbar className="gantt--controls-period" aria-label="Gantt day, week and month view buttons">
      <Button onClick={onDayModeClick}>By day</Button>
      <Button onClick={onWeekModeClick}>By week</Button>
      <Button onClick={onMonthModeClick}>By month</Button>
    </ButtonToolbar>
  </React.Fragment>
);

export default GanttControls;
